import { render, staticRenderFns } from "./FlowList.vue?vue&type=template&id=228dbf8f&"
import script from "./FlowList.vue?vue&type=script&lang=js&"
export * from "./FlowList.vue?vue&type=script&lang=js&"
import style0 from "./FlowList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports